import useStore from '../store/auth'

const getUser = () => {
  const user = useStore.getState().user
  return user
}

export default getUser
